export default {
  API_URL: 'http://api-strangerchat.okituke.com.br',

  BROADCAST_DRIVER: 'pusher',

  PUSHER_APP_KEY: '9f6970e8164f90866974',
  PUSHER_APP_CLUSTER: 'mt1',
  PUSHER_ENCRYPTED: false,
}



// WEBPACK FOOTER //
// ./src/environment.js